<div class="descriptionForBulkOperationContainer">
	<mat-icon class="descriptionIcon" fontSet="fad" fontIcon="fa-tasks" inline />
	{{ T.SHARED_BASIC_ADMINISTRATION_TABLE_CHECKED_ITEM | translate }}
</div>

<mat-form-field color="accent">
	<mat-label>{{ T.SHARED_BASIC_ADMINISTRATION_TABLE_BULK_ACTION | translate }}</mat-label>
	<mat-select [(ngModel)]="selectedBulkAction">
		@for (bulkAction of bulkActions(); track bulkAction.value) {
			<mat-option [value]="bulkAction.value">
				{{ bulkAction.displayNameTranslationKey | translate }}
			</mat-option>
		}
		<mat-option [value]="null">
			{{ T.SHARED_BASIC_ADMINISTRATION_TABLE_NO_ACTION | translate }}
		</mat-option>
	</mat-select>
</mat-form-field>

@if (selectedBulkAction) {
	<sim-button
		class="executeBulkActionBtn"
		size="small"
		[icon]="{fontSet: 'fad', fontIcon: 'fa-check-double'}"
		[label]="T.SHARED_BASIC_ADMINISTRATION_TABLE_EXECUTE"
		(onClick)="executeBulkAction()"
	/>
}
